module.exports = __webpack_public_path__ + "media/images/StanfordMagLogo-4c0fcec07e3661f98b2b9313ba52f6f2.png";